import { apiWithAuth } from "../authApi";
import { Referral } from "@/modules/user/types/referral";

interface ReferralApplyPayload {
  source: "miniapp" | "web";
  referralCode?: string;
  confirm?: boolean;
}

export const postReferralApply = async (
  payload: ReferralApplyPayload
): Promise<Referral | undefined> => {
  try {
    const response = await apiWithAuth.post("/referral/apply", {
      confirm: false,
      ...payload,
    });

    const answer = response.data as Referral;

    return answer;
  } catch (error) {
    return undefined;
  }
};
